import styled from 'styled-components';

export const ProfileImgWrapper = styled.div`
  display: inline-block;
  position: relative;
  text-align: center;
  margin: 30px auto;
  div:last-child {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`;
